module.exports = __webpack_public_path__ + "static/img/238ac1796c8dbd05476a965e11c5ea66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon5.jpg
// module id = Pb3g
// module chunks = 1